jQuery(function ($) {
  /*
    * Slick slider config
    -----------------------------------------------------*/
    $(".slider-2 .et_pb_column").slick({
        slidesToShow: 2,
        infinite: false,
        dots: true,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    $(".slider-3 .et_pb_column").slick({ 
        slidesToShow: 3, 
        infinite: false,
        dots: true,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
    $(".slider-4 .et_pb_column").slick({ 
        slidesToShow: 4, 
        infinite: false,
        dots: true,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});